import { render, staticRenderFns } from "./PlayerList.vue?vue&type=template&id=4a4c98a1&scoped=true&"
import script from "./PlayerList.vue?vue&type=script&lang=js&"
export * from "./PlayerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4c98a1",
  null
  
)

export default component.exports